export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_AUTH_REQUIRED = 'LOGIN_AUTH_REQUIRED'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const GETUSERINFO_SUCCESS = 'GETUSERINFO_SUCCESS'
export const ORG_UPDATE = 'ORG_UPDATE'

export const GETORGDEPTS_SUCCESS = 'GETORGDEPTS_SUCCESS'
export const DEPT_UPDATE = 'DEPT_UPDATE'
export const GETORGDEPTSEMPT_SUCCESS = 'GETORGDEPTSEMPT_SUCCESS'

export const DROPDOWN_SUCCESS = 'DROPDOWN_SUCCESS'

export const GETUSERS_SUCCESS = 'GETUSERS_SUCCESS'

export const GETMENUS_SUCCESS = 'GETMENUS_SUCCESS'
export const GETMENUS_WIDTH_SUCCESS = 'GETMENUS_WIDTH_SUCCESS'

export const GETROLES_SUCCESS = 'GETROLES_SUCCESS'



// WEBPACK FOOTER //
// ./src/store/types.js